<template>
	<CompanyPageContent />
</template>

<script setup>
import CompanyPageContent from '@/components/company/CompanyPageContent.vue';

const title = '国药器械全国分子公司 - 国械在线';
const description = '国械在线依托国药器械全国各省市分子公司网络，为您提供一站式医疗器械采购与批发服务，是您值得信赖的医疗器械供应链服务平台。';
const keywords = '国药器械,国药分子公司,国械在线';

useSeoMeta({
	title,
	ogTitle: title,
	description,
	ogDescription: description,
	ogImage: 'https://uat-cmdc.oss-cn-beijing.aliyuncs.com/productFile/2022/08/18/9af2756f-27bf-4d1e-b0d1-8397e82bb2a0.png',
});

useHead({
	meta: [{ name: 'keywords', content: keywords }],
});
</script>
